module.exports = __webpack_public_path__ + "static/media/bupa hong kong.a4cdf9c3.png";